import PrivacyPolicyLink from './PrivacyPolicyLink';

export default PrivacyPolicyLink;
